import { MapPin } from 'lucide-react';
import { Badge } from './ui/badge';

export const PortfolioCard = ({ project }) => {
  return (
    <div 
      className="portfolio-item group cursor-pointer"
      data-testid={`portfolio-card-${project.id}`}
    >
      <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-muted">
        <img 
          src={project.image_url} 
          alt={project.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground/0 group-hover:bg-foreground/40 transition-colors duration-300" />
        <div className="absolute inset-0 p-6 flex flex-col justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Badge className="w-fit mb-2">{project.category}</Badge>
          <h3 className="text-white text-xl font-medium mb-1">{project.title}</h3>
          <div className="flex items-center gap-1 text-white/80 text-sm">
            <MapPin className="h-4 w-4" />
            {project.location}
          </div>
        </div>
      </div>
      
      <div className="mt-4">
        <div className="flex items-center gap-2 mb-2">
          <Badge variant="outline">{project.category}</Badge>
        </div>
        <h3 className="text-lg font-medium mb-1">{project.title}</h3>
        <p className="text-muted-foreground text-sm line-clamp-2">{project.description}</p>
        <div className="flex items-center gap-1 text-muted-foreground text-sm mt-2">
          <MapPin className="h-4 w-4" />
          {project.location}
        </div>
      </div>
    </div>
  );
};
